import FileData from './FileData'

export default function convertJfifToJpg(dataFile: FileData, quality: number = 0.9): Promise<FileData> {
  return new Promise((resolve, reject) => {
    if (!dataFile.file.type.includes('jfif') && !dataFile.fileName.toLowerCase().endsWith('.jfif')) {
      resolve(dataFile);
      return;
    }

    const newFileName = dataFile.fileName.replace(/\.jfif$/i, '.jpg');
    const reader = new FileReader();

    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          if (!ctx) {
            reject(new Error('Failed to get canvas context'));
            return;
          }

          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;

          ctx.drawImage(img, 0, 0);

          canvas.toBlob((blob) => {
            if (!blob) {
              reject(new Error('Failed to convert image to blob'));
              return;
            }

            const newFile = new File([blob], newFileName, {
              type: 'image/jpeg',
              lastModified: Date.now()
            });

            const newObjectUrl = URL.createObjectURL(newFile);

            if (dataFile.objectUrl) {
              URL.revokeObjectURL(dataFile.objectUrl);
            }

            const newImg = new Image();
            newImg.src = newObjectUrl;

            resolve({
              ...dataFile,
              file: newFile,
              fileName: newFileName,
              objectUrl: newObjectUrl,
              mimeType: 'image/jpeg',
              image: newImg,
              width: canvas.width,
              height: canvas.height,
              fixedMimeType: true
            });

          }, 'image/jpeg', quality);

        } catch (error) {
          reject(error);
        }
      };

      img.onerror = () => {
        reject(new Error('Failed to load image'));
      };

      img.src = event.target?.result as string;
    };

    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };

    reader.readAsDataURL(dataFile.file);
  });
}
